/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestInfoProvider
 */
export interface RequestInfoProvider {
    /**
     * Provider identifier
     */
    provider_id?: number;
    /**
     * Provider name
     */
    provider_name?: string;
}

/**
 * Check if a given object implements the RequestInfoProvider interface.
 */
export function instanceOfRequestInfoProvider(value: object): value is RequestInfoProvider {
    return true;
}

export function RequestInfoProviderFromJSON(json: any): RequestInfoProvider {
    return RequestInfoProviderFromJSONTyped(json, false);
}

export function RequestInfoProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestInfoProvider {
    if (json == null) {
        return json;
    }
    return {
        
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
    };
}

export function RequestInfoProviderToJSON(json: any): RequestInfoProvider {
    return RequestInfoProviderToJSONTyped(json, false);
}

export function RequestInfoProviderToJSONTyped(value?: RequestInfoProvider | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_id': value['provider_id'],
        'provider_name': value['provider_name'],
    };
}

